<template>
    <div class="comment_wrap">
        <div class="comment_form">
            <span class="wrap_title">댓글 목록</span>

            <form>
                <textarea ref="commentRef" v-model="state.comment" placeholder="댓글을 입력해주세요"></textarea>
                <div class="comment_btn">
                    <button class="_blue" @click.prevent="add">등록</button>
                </div>
            </form>
        </div>
        <div class="comment_list">
            <ul class="custom_scroll">
                <template v-if="state.list != null && state.list.length > 0">
                    <li style="gap: 0 !important" v-for="comment in state.list" :key="comment.idx">
                        <div class="comment_list_info">
                            <span class="name">다시함께상담센터</span>
                            <span class="date">{{ CommonUtils.dateFormat(new Date(comment.createDate), ".", true) }}</span>
                            <div class="comment_btn">
                                <template v-if="!comment.isEditMode">
                                    <button class="_blue" @click="edit(comment)">수정</button>
                                    <button class="_gray" @click="remove(comment.idx)">삭제</button>
                                </template>
                                <template v-else>
                                    <button class="_blue" @click="editApi(comment.content)">저장</button>
                                    <button class="_gray" @click="comment.isEditMode = false">취소</button>
                                </template>
                            </div>
                        </div>
                        <p class="comment_con" v-html="comment.content" v-if="!comment.isEditMode"></p>
                        <textarea class="text_over" v-else v-model="comment.content"></textarea>
                    </li>
                </template>
                <li class="no_list" v-else>등록된 댓글이 없습니다.</li>
            </ul>
        </div>
    </div>
    <ModalDefault
        v-if="modal.isShowModal"
        :type="modal.tab"
        :title="modal.title"
        :content="modal.content"
        @close="closeModal2"
        @callback="callBackModal"
    ></ModalDefault>
</template>

<script setup lang="ts">
    import { apiService, onMounted, reactive, types, watch, ModalDefault, getMessageByCode, ref, CommonUtils } from "@/BaseComponent";

    interface Props {
        idx?: number;
        type?: 1 | 2;
    }

    const props = defineProps<Props>();
    const commentRef = ref<HTMLTextAreaElement | null>(null);
    const state = reactive({
        isEditMode: false as boolean,
        editIdx: 0 as number,
        removeIdx: 0 as number,
        list: [] as any[],
        comment: "" as string,
        page: 0 as number,
        size: 10 as number,
    });

    const modal = reactive({
        isShowModal: false,
        tab: -1 as number,
        isResult: false as boolean,
        title: "alert" as string,
        content: "" as string,
    });

    const checkValue = (comment: string) => {
        if (comment === "" || comment === null || comment === undefined) {
            return false;
        } else {
            return true;
        }
    };

    const initComment = () => {
        state.isEditMode = false;
        state.comment = "";
        state.editIdx = 0;
        state.removeIdx = 0;
    };

    onMounted(() => {
        if (props.idx) getList();
    });

    watch(
        () => props.idx,
        () => {
            if (props.idx) {
                getList();
            }
        },
    );
    const getList = async () => {
        const param: types.ReqReportCommentList = {
            page: state.page,
            size: state.size,
            searchType: null,
            searchText: null,
        };

        const res: types.ResReportCommentList = await apiService.report.commentList(props.idx!, param);

        if (res.returnCode === 0) {
            state.list = res.list.data;
        } else if (res.returnCode === 11) {
        } else {
            console.error(res.description);
        }
    };

    const add = async () => {
        if (checkValue(state.comment)) {
            const param: types.ReqReportComment = {
                type: props.type!,
                idx: props.idx!,
                content: state.comment,
            };
            const res = await apiService.report.commentAdd(param);
            if (res.returnCode === 0) {
                modal.tab = 8;
                modal.title = "알림";
                modal.content = "저장이 완료되었습니다.";
                modal.isShowModal = true;
                getList();
                initComment();
            } else if (res.returnCode === 11) {
            } else {
                modal.tab = 8;
                modal.title = "예외 발생";
                modal.content = getMessageByCode(res.returnCode);
                modal.isShowModal = true;
            }
        } else {
            modal.tab = -1;
            modal.title = "예외 발생";
            modal.content = "댓글을 입력해주세요";
            modal.isShowModal = true;
        }
    };

    const edit = (item: any) => {
        state.isEditMode = true;
        state.editIdx = item.idx;
        item.isEditMode = true;
    };

    const editApi = async (comment: string) => {
        if (checkValue(comment)) {
            const param: types.ReqReportComment = {
                type: props.type!,
                idx: state.editIdx,
                content: comment,
            };

            const res = await apiService.report.commentModify(param);
            if (res.returnCode === 0) {
                modal.tab = 8;
                modal.title = "알림";
                modal.content = "저장이 완료되었습니다.";
                modal.isShowModal = true;
                getList();
                initComment();
            } else if (res.returnCode === 11) {
            } else {
                modal.tab = 8;
                modal.title = "예외 발생";
                modal.content = getMessageByCode(res.returnCode);
                modal.isShowModal = true;
            }
        } else {
            modal.tab = -1;
            modal.title = "예외 발생";
            modal.content = "댓글을 입력해주세요";
            modal.isShowModal = true;
        }
    };

    const remove = async (idx: number) => {
        state.removeIdx = idx;
        modal.tab = 5;
        modal.title = "알림";
        modal.content = "댓글을 삭제하시겠습니까?";
        modal.isShowModal = true;
    };

    const removeForComfirm = async (idx: number) => {
        const res = await apiService.report.commentDelete(props.type!, idx);
        if (res.returnCode === 0) {
            modal.tab = 8;
            modal.title = "알림";
            modal.content = "삭제가 완료되었습니다.";
            modal.isShowModal = true;

            getList();
        } else if (res.returnCode === 11) {
        } else if (res.returnCode === 19) {
            modal.tab = 8;
            modal.title = "삭제 실패";
            modal.content = "비밀번호를 잘못 입력하셨네요.";
            modal.isShowModal = true;
        } else if (res.returnCode === 22) {
            modal.tab = 8;
            modal.title = "알림";
            modal.content = "비밀번호가 일치하지 않습니다.";
            modal.isShowModal = true;
        } else {
            modal.tab = 8;
            modal.title = "예외 발생";
            modal.content = getMessageByCode(res.returnCode);
            modal.isShowModal = true;
        }
    };

    const closeModal2 = () => {
        modal.isShowModal = false;
        modal.tab = -1;
    };

    const callBackModal = async (param: any) => {
        if (param.action === "confirm") {
            switch (modal.tab) {
                case 5:
                    removeForComfirm(state.removeIdx);
                    break;
            }
        }
    };
</script>

<style>
    .parts {
        gap: 20px;
    }
    .left_part {
        width: 50%;
    }
    .right_part {
        width: 50%;
    }
    .report_modal {
        overflow-y: auto;
        max-height: calc(100% - 118px);
    }
    .pop_up.flex_box:has(.report_modal) {
        height: calc(100vh - (var(--header_h) * 2));
    }
    .comment_form .wrap_title {
        margin-bottom: 10px;
        font-weight: bold;
        display: block;
    }
    .comment_form textarea {
        width: 100%;
        height: 55px;
        flex: 1;
        font-size: 14px;
    }
    .comment_form form {
        align-items: stretch;
        display: flex;
        gap: 5px;
    }

    .comment_form .comment_btn button {
        height: 100%;
    }
    .comment_btn button {
        padding: 2px 5px;
        color: #fff;
        border-radius: 5px;
    }
    .comment_list_info {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 14px;
    }
    .comment_list_info .name {
        font-weight: 500;
    }
    .comment_list_info .date {
        color: #6d6d6d;
    }
    .comment_list {
        margin-top: 20px;
    }
    .comment_list ul li:first-child {
        margin-top: 0;
    }
    .comment_list ul li {
        margin-top: 10px;
        background-color: #fff;
        box-shadow: 0px 0px 10px #dededeaf;
        padding: 15px;
    }
    .comment_list ul li textarea {
        width: 100%;
        margin-top: 10px;
        font-size: 14px;
    }
    .comment_list ul li textarea:read-only {
        border: 0;
        padding: 0;
    }
    .comment_wrap {
        background-color: #f5f5f5;
        padding: 15px;
        margin-top: 20px;
    }
    .comment_btn {
        display: flex;
        gap: 2px;
    }
    .no_list {
        font-size: 14px;
        text-align: center;
    }
    .comment_con {
        font-size: 14px;
        white-space: pre-line;
        color: #232323;
        margin-top: 5px;
    }
</style>
